export default {
  setJourneys(state, journeys) {
    state.journeys = journeys
  },
  setJourney(state, journey) {
    state.journey = journey
  },
  resetJourney(state) {
    state.journey = null
  },
  setLoading(state, loading) {
    state.loading = loading
  },
  updatePositiveAction(state, { positiveActionId, updatedAction }) {
    if (state.journey?.content?.positiveActions) {
      const index = state.journey.content.positiveActions.findIndex(
        action => action.id === positiveActionId,
      )
      if (index !== -1) {
        state.journey.content.positiveActions.splice(index, 1, updatedAction)
      }
    }
  },
  updateTimedMessage(state, { timedMessageId, updatedMessage }) {
    if (state.journey?.content?.timedMessages) {
      const index = state.journey.content.timedMessages.findIndex(
        message => message.id === timedMessageId,
      )
      if (index !== -1) {
        state.journey.content.timedMessages.splice(index, 1, updatedMessage)
      }
    }
  },
  updateCourseLesson(state, { lessonId, updatedLesson }) {
    if (state.journey?.content?.course?.lessons) {
      const index = state.journey.content.course.lessons.findIndex(
        lesson => lesson.id === lessonId,
      )
      if (index !== -1) {
        state.journey.content.course.lessons.splice(index, 1, updatedLesson)
      }
    }
  },
}
